export const LanguagesMap = [
    { name: "English - English (en)", code: "en" },
    { name: "Arabic - العربية (ar)", code: "ar" },
    { name: "Finnish - Suomi (fi)", code: "fi" },
    { name: "French - Français (fr)", code: "fr" },
    { name: "German - Deutsch (de)", code: "de" },
    { name: "Japanese - 日本語 (ja)", code: "ja" },
    { name: "Korean - 한국어 (ko)", code: "ko" },
    { name: "Simplified Chinese - 简体中文 (ZH)", code: "zh" },
    { name: "Swedish - Svenska (sv)", code: "sv" },
    { name: "Spanish - Español (es)", code: "es" }
];

export const runtimeLanguageMap = [
    { code: "ar", runtimeCode: "ar" },
    { code: "de", runtimeCode: "de" },
    { code: "en", runtimeCode: "en" },
    { code: "fi", runtimeCode: "fi" },
    { code: "fr", runtimeCode: "fr" },
    { code: "ja", runtimeCode: "ja" },
    { code: "ko", runtimeCode: "ko" },
    { code: "sv", runtimeCode: "sv" },
    { code: "zh", runtimeCode: "zh" },
    { code: "es", runtimeCode: "es" }
];